export const LONG_SELECT_DELAY = 1000;
export const LONG_SELECT_ERROR_THRESHOLD = 3;
